import MeApiAgent from '@/auth/signin/agent/MeApiAgent';
import { postPlatformAuthToken, updateStatus } from '@/auth/signin/agent/OnboardingApiAgent';
import { useProfile } from '@/auth/signin/datacontroller/AuthContext';
import { OnboardingStatus } from '@/auth/signin/model/AuthTypes';
import { handleError } from '@/common/agent/ApiAgent';
import Spinner from '@/common/view/Spinner';
import MainController, { PATH } from '@/main/controller/MainController';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const PageFrame = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.grayWhite};
  display: flex;
  align-items: center;
`;

const LoadingView = () => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <Spinner />
    </div>
  );
};

export const AuthRedirectPage = () => {
  const [searchParams] = useSearchParams();
  const { profile, setProfile } = useProfile();
  const navigate = useNavigate();

  const code = searchParams.get('code');
  const state = searchParams.get('state');

  const startMigrationProcess = async (code: string, state: string) => {
    try {
      // Fetch latest user profile
      await postPlatformAuthToken(code, state);
      await updateStatus(profile!.mall_id!, OnboardingStatus.MigrationInProgress);
      const p = await MeApiAgent.getMe();
      if (p) MainController.onSignin(p);
      setProfile(p);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    // 성공 시
    // Location: {redirect_uri}?code={authorization_code}&state={encode_csrf_token}
    // 에러 시
    // Location: {redirect_uri}?error={error}&state={encode_csrf_token}&trace_id={trace_id}

    if (!code || !state || !profile) {
      navigate(PATH.MAIN, { replace: true });
      return;
    }

    const onboardingStatus = profile.onboarding_status;
    if (onboardingStatus === OnboardingStatus.IntegrationRequired) {
      startMigrationProcess(code, state).then(() => {
        navigate(PATH.ONBOARDING, { replace: true });
      });
    } else if (onboardingStatus === OnboardingStatus.OnboardingComplete) {
      postPlatformAuthToken(code, state).then(() => {
        navigate(PATH.ONBOARDING, { replace: true });
      });
    } else {
      navigate(PATH.ONBOARDING, { replace: true });
    }
  }, [code, state, profile]);

  return (
    <PageFrame>
      <LoadingView />
    </PageFrame>
  );
};
